var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-list',{attrs:{"itemLayout":"horizontal","dataSource":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }